module.exports = __webpack_public_path__ + "static/media/birth_rate.024f3103.png";